import React from 'react';

import { PlainReferenceChip } from './PlainReferenceChip';
import type { ReferenceTriggerProps } from './referenceKinds';
import { TEXTS } from './texts';

/** A cited SOP: the sentence's own words, and on hover that they come from the SOP. Nothing opens on click. */
export const SopReferenceTrigger: React.FC<ReferenceTriggerProps> = ({ reference, children }) => (
  <PlainReferenceChip asText label={children} title={TEXTS.FROM_SOP} secondary={reference.name ?? undefined} />
);
